import { createSelector } from 'reselect';

import { Resources } from '../constants';
import { countryTaxTypeDescriptionsSelector } from '../../../shared/store/selectors';

export const configurationSettingsSelector = ({ reports }) => reports.configurationSettings;

export const isLoadingConfigurationSettingsPillSelector = ({ reports }) => pillType =>
  reports.configurationSettings.loading[Resources[pillType]];

export const isLoadingConfigurationSettingsSelector = createSelector(
  ({ reports }) => reports.configurationSettings.loading,
  pillsLoading => Object.values(pillsLoading).some(pill => pill === true)
);

export const fetchingProgressSelector = ({ reports }) => {
  const loadingState = reports.configurationSettings.loading;

  return Object.values(loadingState).filter(fetched => !fetched).length;
};

export const countryTaxTypesSelector = createSelector(
  countryTaxTypeDescriptionsSelector,
  countryTaxTypes => countryTaxTypes
    ? Object.entries(countryTaxTypes).map(([key, value]) => ({ description: value, countryTaxType: key }))
    : []
);
